import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { VueAxios } from './axios'
import {Modal, notification} from 'ant-design-vue'
import { ACCESS_TOKEN, TENANT_ID } from "@/store/mutation-types"
import { getAccessToken, removeAccessToken } from '@/utils/token'
import eventBus from '@/utils/eventBus'

/**
 * 【指定 axios的 baseURL】
 * 如果手工指定 baseURL: '/jeecg-boot'
 * 则映射后端域名，通过 vue.config.js
 * @type {*|string}
 */
let apiBaseUrl = window._CONFIG['domianURL'] || "/jeecg-boot";
//console.log("apiBaseUrl= ",apiBaseUrl)
// 创建 axios 实例
const service = axios.create({
  //baseURL: '/jeecg-boot',
  baseURL: apiBaseUrl, // api base_url
  timeout: 600000 // 请求超时时间
})

// 401/Token失效并发互斥：同一时刻只处理一次登出跳转，避免弹窗风暴与重复 reload
let unauthorizedLock = false

const err = (error) => {
  if (error.response) {
    let data = error.response.data
    const token = getAccessToken()
    console.log("------异常响应------",token)
    console.log("------异常响应------",error.response.status)
    switch (error.response.status) {
      case 403:
        notification.error({ message: '系统提示', description: '拒绝访问',duration: 4})
        break
      case 500:
        console.log("------error.response------",error.response)
        // update-begin- --- author:liusq ------ date:20200910 ---- for:处理Blob情况----
        let type=error.response.request.responseType;
        if(type === 'blob'){
          blobToJson(data);
          break;
        }
        // update-end- --- author:liusq ------ date:20200910 ---- for:处理Blob情况----
        //notification.error({ message: '系统提示', description:'Token失效，请重新登录!',duration: 4})
        if(token && data.message.includes("Token失效")){
          // update-begin- --- author:scott ------ date:20190225 ---- for:Token失效采用弹框模式，不直接跳转----
          Modal.error({
            title: '登录已过期',
            content: '很抱歉，登录已过期，请重新登录',
            okText: '重新登录',
            mask: false,
            onOk: () => {
              store.dispatch('Logout').then(() => {
                removeAccessToken()
                try {
                  let path = window.document.location.pathname
                  console.log("location pathname -> "+path)
                  if(path!="/" && path.indexOf('/user/login')==-1){
                    window.location.reload()
                  }
                }catch (e) {
                  window.location.reload()
                }
              })
            }
          })
          // update-end- --- author:scott ------ date:20190225 ---- for:Token失效采用弹框模式，不直接跳转----
        }
        break
      case 404: {
        // 预期性 404 静默忽略：喜报轮询 / 筛选模板接口在旧后端不存在，避免 F5 刷新弹"资源未找到"
        const notifyUrl = (error && error.config && error.config.url) || ''
        if (notifyUrl.indexOf('/dmPlatformNotify/') > -1) break
        if (notifyUrl.indexOf('/dm/dmSearchParam/') > -1) break
        if (notifyUrl.indexOf('/api/workorderApi/') > -1) break
        if (notifyUrl.indexOf('/dmComplateInformation/selectCarInformationById') > -1) break
        notification.error({ message: '系统提示', description: '很抱歉，资源未找到!', duration: 4})
        break
      }
      case 504:
        notification.error({ message: '系统提示', description: '网络超时'})
        break
      case 401:
        // 并发 401 互斥：已在处理登出跳转时，后续 401 直接忽略，避免弹窗风暴与多次 reload
        if (unauthorizedLock) break
        unauthorizedLock = true
        notification.error({ message: '系统提示', description:'未授权，请重新登录',duration: 4})
        if (token) {
          store.dispatch('Logout').then(() => {
            setTimeout(() => {
              window.location.reload()
            }, 1500)
          })
        }
        break
      default:
        notification.error({
          message: '系统提示',
          description: data.message,
          duration: 4
        })
        break
    }
  }
  return Promise.reject(error)
};

// request interceptor
service.interceptors.request.use(config => {
  const token = getAccessToken()
  if (token) {
    config.headers[ 'X-Access-Token' ] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  //update-begin-author:taoyan date:2020707 for:多租户
  let tenantid = Vue.ls.get(TENANT_ID)
  if (!tenantid) {
    tenantid = 0;
  }
  config.headers[ 'tenant_id' ] = tenantid
  //update-end-author:taoyan date:2020707 for:多租户
  if(config.method=='get'){
    if(config.url.indexOf("sys/dict/getDictItems")<0){
      config.params = {
        _t: Date.parse(new Date())/1000,
        ...config.params
      }
    }
  }
  return config
},(error) => {
  return Promise.reject(error)
})

// response interceptor
service.interceptors.response.use((response) => {
    // 角标统计实时刷新（A 方案·操作事件驱动）：写操作成功且命中角标相关模块 → 通知全局刷新统计
    notifyStatisticsRefresh(response)
    return response.data
  }, err)

const installer = {
  vm: {},
  install (Vue, router = {}) {
    Vue.use(VueAxios, router, service)
  }
}
/**
 * 角标统计实时刷新触发器（A 方案：操作事件驱动）
 * 命中规则：写操作（POST/PUT/DELETE）+ 角标相关模块接口 + 成功响应 → 触发全局 statistics-refresh 事件
 * 5s 防抖：高频写操作（连续保存等）合并为一次刷新，配合 GlobalLayout 的 60s 兜底定时与可见性刷新
 */
const STAT_MODULES = ['dmWorkOrder', 'dmDriver', 'dmCar', 'jsRecord', 'dmJs', 'notice', 'dmPlatform', 'rankApi', 'dmCustomer']
const STAT_ACTIONS = ['save', 'add', 'edit', 'update', 'delete', 'remove', 'handle', 'audit', 'approve', 'hang', 'complete', 'finish', 'cancel', 'read', 'batch', 'set', 'close', 'end', 'remark', 'transfer', 'restart', 'reopen', 'assign', 'submit', 'confirm', 'agree', 'reject', 'stop', 'start', 'sign', 'verify', 'bind', 'unbind']
let _lastStatNotify = 0
function notifyStatisticsRefresh(response) {
  try {
    const cfg = response && response.config
    if (!cfg) return
    const method = (cfg.method || '').toLowerCase()
    if (['post', 'put', 'delete'].indexOf(method) === -1) return
    const url = cfg.url || ''
    if (!STAT_MODULES.some(m => url.indexOf(m) !== -1)) return
    if (!STAT_ACTIONS.some(a => url.toLowerCase().indexOf(a) !== -1)) return
    const data = response.data
    if (!data || data.success !== true) return
    const now = Date.now()
    if (now - _lastStatNotify < 5000) return
    _lastStatNotify = now
    eventBus.$emit('statistics-refresh')
  } catch (e) {
    // 统计刷新通知失败不影响业务请求
  }
}

/**
 * Blob解析
 * @param data
 */
function blobToJson(data) {
  let fileReader = new FileReader();
  let token = getAccessToken();
  fileReader.onload = function() {
    try {
      let jsonData = JSON.parse(this.result);  // 说明是普通对象数据，后台转换失败
      console.log("jsonData",jsonData)
      if (jsonData.status === 500) {
        console.log("token----------》",token)
        if(token && jsonData.message.includes("Token失效")){
          Modal.error({
            title: '登录已过期',
            content: '很抱歉，登录已过期，请重新登录',
            okText: '重新登录',
            mask: false,
            onOk: () => {
              store.dispatch('Logout').then(() => {
                removeAccessToken()
                window.location.reload()
              })
            }
          })
        }
      }
    } catch (err) {
      // 解析成对象失败，说明是正常的文件流
      console.log("blob解析fileReader返回err",err)
    }
  };
  fileReader.readAsText(data)
}

export {
  installer as VueAxios,
  service as axios
}